"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

var _vue = _interopRequireDefault(require("vue"));

var _default = {
  name: "permission-page",
  data: function data() {
    return {
      hasViewPermission: this.hasPermissionEx("view"),
      hasAddPermission: this.hasPermissionEx("add"),
      hasUpdatePermission: this.hasPermissionEx("update"),
      hasDeletePermission: this.hasPermissionEx("delete"),
      hasImportPermission: this.hasPermissionEx("import"),
      hasExportPermission: this.hasPermissionEx("export")
    };
  },
  computed: {},
  methods: {
    hasPermissionEx: function hasPermissionEx(permissionSuffix) {
      // return this.hasPermission(this.$options.permission + permissionSuffix);
      if (this.$route.name) {
        return this.$store.getters["user/hasPermission"](this.$route.name.split(':')[0] + ":" + permissionSuffix);
      }

      return false;
    },
    hasPermission: function hasPermission(permissionSuffix) {
      // return this.hasPermission(this.$options.permission + permissionSuffix);
      return this.$store.getters["user/hasPermission"](this.$route.name.split(':')[0] + ":" + permissionSuffix);
    },
    saveFile: function saveFile(fileName, data) {
      var blob = new Blob([data], {
        type: "application/octet-stream"
      });
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); //创建下载的链接

      downloadElement.href = href;
      downloadElement.download = fileName; //下载后文件名

      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载

      document.body.removeChild(downloadElement); //下载完成移除元素

      window.URL.revokeObjectURL(href); //释放掉blob对象
    }
  }
};
exports.default = _default;